export default "__VITE_ASSET__BPWyjX5g__"